import * as types from '../ActionTypes/BookedUsersActionTypes';

const intialState = {
    loading: false,
    entities: [],
    err: false,
};

export function BookedUsersReducer(state = intialState, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_BOOKED_USERS:
            return { ...intialState, loading: true };

        case types.GET_BOOKED_USERS + types.SUCCESS:
            return { ...intialState, loading: false, entities: [...payload], err: false };

        case types.GET_BOOKED_USERS + types.EMPTY:
            return { ...intialState, loading: false, entities: [], err: false };

        case types.GET_BOOKED_USERS + types.FAIL:
            return { ...intialState, loading: false, entities: [], err: true };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/Store/Reducers/BookedUsersReducer.js